import { Badge } from '@/components/ui/badge';
import { isExpired } from '@/lib/utils/date';
import type { UserRow } from '../types';

interface UserStatusBadgeProps {
  user: Pick<UserRow, 'deleted' | 'expiryDate'>;
}

/**
 * Three-state status — Expired (validity past), Inactive (deleted=1),
 * Active otherwise. Matches the legacy "Validity Expired" / "Active" /
 * "In-Active" semantics from the user list.
 */
export function UserStatusBadge({ user }: UserStatusBadgeProps) {
  if (user.expiryDate && isExpired(user.expiryDate)) {
    return <Badge variant="warning">Expired</Badge>;
  }
  if (user.deleted === 1) {
    return <Badge variant="destructive">Inactive</Badge>;
  }
  return <Badge variant="success">Active</Badge>;
}
